module.exports = __webpack_public_path__ + "img/afp_logo.87747897.png";